
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.102 8.883a4.531 4.531 0 10-4.454 0 7.312 7.312 0 00-3.78 2.766.47.47 0 00.109.656.477.477 0 00.656-.11 6.406 6.406 0 0110.484-.007.47.47 0 00.656.117.477.477 0 00.11-.656 7.375 7.375 0 00-3.781-2.766zm-5.82-3.945a3.594 3.594 0 117.187 0 3.594 3.594 0 01-7.188 0zm15.859 7.367a.515.515 0 01-.274.086.46.46 0 01-.383-.203 6.407 6.407 0 00-5.242-2.72.469.469 0 110-.937 3.594 3.594 0 100-7.187c-.33.001-.658.046-.976.133a.469.469 0 11-.25-.899 4.531 4.531 0 013.46 8.305 7.328 7.328 0 013.774 2.766.477.477 0 01-.11.656z","fill":"#80A0AF"}})])
          )
        }
      }
    